<template>
  <div class="intelligentAgriculture-page">
    <!-- 智慧农业 -->
    <div class="haeder-container blackStatic" style="height:141px;">
      <Header></Header>
      <Nav></Nav>
    </div>

        <div class="swiper-container">
			<div class="swiper-wrapper">
				<div class="swiper-slide">
					<div class="main-bunner-img-01">
					</div>
				</div>
				<div class="swiper-slide">
					<div class="main-bunner-img-02">
					</div>
				</div>
				<!-- 如果需要导航按钮 -->
				<div class="swiper-button-prev"></div>
				<div class="swiper-button-next"></div>
			</div>
		</div>
		<!-- 列表 -->
		<div class="maim-module-center">
			<div class="maim-module-h3">
				<span class="h3-ico"></span>
				<span class="h3-text">产品中心</span>
			</div>
			<div class="hr">
			</div>
			<div class="maim-module-center-list">
				<div class="maim-module-center-list-model">
					<div class="maim-module-center-list-img-01">
					</div>
					<div class="maim-module-01-center-list-h4">
						<span>农业智能环境监控系统</span>
					</div>
					<p class="lineHeight20">
						国内最领先的农业环境智能监控(农业物联网）软硬件整体解决方案
						结合了最先进的物...
					</p>
				</div>
				<div class="maim-module-center-list-model">
					<div class="maim-module-center-list-img-02">
					</div>
					<div class="maim-module-01-center-list-h4">
						<span>温室智能监控系统</span>
					</div>
					<p class="lineHeight20">
						实时远程获取温室大棚内部的空气温湿度、土壤水份温度、二氧化碳
						浓度、光照强度及视频...
					</p>
				</div>
				<div class="maim-module-center-list-model">
					<div class="maim-module-center-list-img-03">
					</div>
					<div class="maim-module-01-center-list-h4">
						<span>一体化室外气象站</span>
					</div>
					<p class="lineHeight20">
						一体化室外气象站可以远程实时采集前端的多种气象要素，是农作
						物“四情”（苗情、...
					</p>
				</div>
				<div class="maim-module-center-list-model">
					<div class="maim-module-center-list-img-04">
					</div>
					<div class="maim-module-01-center-list-h4">
						<span>病虫害智能监测系统</span>
					</div>
					<p class="lineHeight20">
						农作物病虫害在线监测系统由包含虫信息自动采集传输、远程病害
						监测仪、农田生态远程...
					</p>
				</div>
				<div class="maim-module-center-list-model">
					<div class="maim-module-center-list-img-05">
					</div>
					<div class="maim-module-01-center-list-h4">
						<span>养殖场智能监控系统</span>
					</div>
					<p class="lineHeight20">
						养殖场智能环境监控系统结合了最先进的网络通信、自动控制、物联
						网及软件技术制
					</p>
				</div>
				<div class="maim-module-center-list-model">
					<div class="maim-module-center-list-img-06">
					</div>
					<div class="maim-module-01-center-list-h4">
						<span>智能节水灌溉控制系统</span>
					</div>
					<p class="lineHeight20">
						基于百倍云物联网通用平台和云计算技术，结合自动控制技术和专家
						系统技术、传感器技术...
					</p>
				</div>
				<div class="maim-module-center-list-model">
					<div class="maim-module-center-list-img-07">
					</div>
					<div class="maim-module-01-center-list-h4">
						<span>墒情监测站</span>
					</div>
					<p class="lineHeight20">
						土壤墒情监测站实现对土壤墒情（土壤湿度）的长时间连续监测。
						用户可以根据监测需...
					</p>
				</div>
				<div class="maim-module-center-list-model">
					<div class="maim-module-center-list-img-08">
					</div>
					<div class="maim-module-01-center-list-h4">
						<span>农业智能环境监控系统</span>
					</div>
					<p class="lineHeight20">
						百倍云农产品质量安全追溯系统，利用二维码和RFID无线射频技术
						针对农产品从生...
					</p>
				</div>
				<div class="maim-module-center-list-model">
					<div class="maim-module-center-list-img-09">
					</div>
					<div class="maim-module-01-center-list-h4">
						<span>农事管理系统</span>
					</div>
					<p class="lineHeight20">
						结合了最先进的物联网及软件技术以及百倍云在物联网领域丰富的
						实践经验，为农场等...
					</p>
				</div>
				<div class="maim-module-center-list-model">
				</div>
			</div>
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

		
export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
      			var mySwiper = new Swiper('.swiper-container', {
				slidesPerView: 1,
				autoplay: {
					disableOnInteraction: false, //手动滑动之后不打断播放
					delay: 2000
				},
				pagination: '.swiper-pagination',
				paginationClickable: true,
				paginationType: 'custom',
				spaceBetween: 30,
				loop: true,
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev'
			})
  },
  methods: {
  }
}
</script>
<style>
.lineHeight20{
	line-height: 22px;
	margin-bottom: 10px;
}
.haeder-container {
	width: 100%;
	height: 129px;
	margin: 0 auto;
	background-color: #030512;
}


div:after,
li:after,
ul:after {
	clear: both;
	content: "";
	width: 0;
	height: 0;
	display: block;
	visibility: hidden;
}

.header-page .header-left-container .header-describe {
	float: left;
	font-size: 16px;
	color: #f1f3f8;
}

/* CSS Document */
*{
    margin:0;
    padding:0;
}
html, body, div, span, object, iframe,h1, h2, 
h3, h4, h5, h6, p, blockquote, pre,abbr, address, cite, code,del, dfn, 
em, img, ins,kbd, q, samp,small, strong, sub, sup, var,b, i,dl, dt, dd, 
ol, ul, li,fieldset, form, label, legend,table, caption, tbody, 
tfoot,thead,tr, th, td,article, aside, canvas, details, figcaption, 
figure, footer, header, hgroup, menu, nav, section, summary,time, mark, 
audio, video {
    margin:0;
    padding:0;
    border:0;
    outline:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    outline-style:none;
}
 
body {
    line-height:1;
}
ol, ul{
    text-decoration: none;
    list-style: none;
}
a{
    margin:0;
    padding:0;
    border:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    text-decoration:none;
    outline-style:none;
}
a:hover,a:focus{
    text-decoration:none;
    outline-style:none;
    }
table {
    border-collapse:collapse;
    border-spacing:0;
}
input, select {
    vertical-align:middle;
}
.clear{
    clear: both;
}










.foot-page {
	background: #03030c;
}

.foot-page .foot-container {
	width: 1200px;
	margin: 0 auto;
}

.foot-page .foot-container .more-info-container {
	padding: 60px 0 40px;
}

.foot-page .foot-container .more-info-container .more-left-info-container {
	float: left;
}

.foot-page .foot-container .more-info-container .more-left-info-container .logo {
	width: 168px;
	margin-top: 30px;
	margin-bottom: 46px;
}

.foot-page .foot-container .more-info-container .more-left-info-container img {
	width: 100%;
	height: 100%;
	display: block;
}

div:after,
li:after,
ul:after {
	clear: both;
	content: "";
	width: 0;
	height: 0;
	display: block;
	visibility: hidden;
}

.foot-page .foot-container .more-info-container .more-left-info-container .contact-info {
	width: 250px;
}

.foot-page .foot-container .more-info-container .more-left-info-container img {
	width: 100%;
	height: 100%;
	display: block;
}

.foot-page .foot-container .more-info-container .more-other-info-container {
	float: left;
	display: flex;
	margin-left: 70px;
}

.foot-page .foot-container .more-info-container .more-other-info-container .more-otherInfo-list-container .more-otherInfo-title-container {
	font-size: 16px;
	color: #fff;
	margin-bottom: 18px;
}

.foot-page .foot-container .more-info-container .more-other-info-container .more-otherInfo-list-container .more-otherInfo-item-container {
	line-height: 30px;
}

.foot-page .foot-container .more-info-container .more-other-info-container .more-otherInfo-list-container .more-otherInfo-item-container a {
	font-size: 14px;
	color: #5e5c60;
}

.foot-page .foot-container .more-info-container .more-right-info-container {
	float: right;
	text-align: left;
	box-shadow: 0 0 black;
}

.foot-page .foot-container .more-info-container .more-right-info-container .more-right-info-title {
	font-size: 16px;
	color: #fff;
	margin-bottom: 20px;
}

.foot-page .foot-container .more-info-container .more-right-info-container .erweima {
	width: 120px;
}

.foot-page .foot-container .more-info-container .more-right-info-container .erweima img {
	width: 100%;
	height: 100%;
	display: block;
}

.foot-page .copyright-info-container {
	height: 50px;
	line-height: 50px;
	text-align: center;
	font-size: 12px;
	color: #5e5c60;
	border-top: 1px solid #434343;
}

a {
	cursor: pointer;
	text-decoration: none;
	outline: none !important;
}




/* 媒体查询 */
@media all and (max-width: 1400px) and (min-width: 820px) {
	.swiper-container {
		width: 100%;
		height: 600px !important;
	}
}

.main {
	background-color: #FFFFFF;
}

.main-bunner-img-01 {
	width: 100%;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/tc23.png);
	background-repeat: no-repeat;
	height: 100%;
	background-size: cover;
}

.main-bunner-img-02 {
	width: 100%;
	height: 100%;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/banner2.png);
	background-repeat: no-repeat;
	background-size: contain;
}

.maim-module-center {
	width: 85%;
	margin: 0 auto 60px;
}

.maim-module-h3 {
	margin-top: 55px;
	margin-bottom: 35px;
}

.h3-ico {
	display: inline-block;
	width: 4px;
	height: 19px;
	background: rgba(10, 169, 114, 1);
}

.h3-text {
	width: 76px;
	height: 18px;
	line-height: 18px;
	display: inline-block;
	font-size: 18px;
	font-family: PingFang SC;
	font-weight: bold;
	color: rgba(44, 44, 46, 1);
}

.hr {
	margin: 25px 0;
	width: 100%;
	height: 2px;
	background: rgba(237, 237, 237, 1);
}

.maim-module-center-list {
	display: flex;
	justify-content: space-between;
	flex-flow: wrap;
}

.maim-module-center-list-model {
	width: 30%;
	margin-bottom: 5px;
}

.maim-module-center-list-img-01 {
	width: 100%;
	height: 305px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/imgbg1.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.maim-module-center-list-img-02 {
	width: 100%;
	height: 305px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/imgbg2.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.maim-module-center-list-img-03 {
	width: 100%;
	height: 305px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/imgbg3.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.maim-module-center-list-img-04 {
	width: 100%;
	height: 305px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/imgbg4.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.maim-module-center-list-img-05 {
	width: 100%;
	height: 305px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/imgbg6.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.maim-module-center-list-img-06 {
	width: 100%;
	height: 305px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/imgbg7.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.maim-module-center-list-img-07 {
	width: 100%;
	height: 305px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/imgbg8.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.maim-module-center-list-img-08 {
	width: 100%;
	height: 305px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/imgbg9.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.maim-module-center-list-img-09 {
	width: 100%;
	height: 305px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/imgbg10.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.maim-module-01-center-list-h4 {
	text-align: center;
	width: 100%;
	margin: 18px 0 10px;
}

.maim-module-01-center-list-h4 span {
	width: 166px;
	height: 16px;
	display: inline-block;
	font-size: 16px;
	font-family: PingFang SC;
	font-weight: bold;
	color: rgba(51, 51, 51, 1);
}

.maim-module-center-list-model p {
	text-align: center;
	margin-bottom: 18px;
	width: 100%;
	height: 31px;
	display: inline-block;
	font-size: 14px;
	font-family: PingFang SC;
	font-weight: bold;
	color: rgba(102, 102, 102, 1);
}

/* 轮播 */

.swiper-container {
	width: 100%;
	height: 700px;
}

.haeder-container {
	width: 100%;
	height: 131px;
	margin: 0 auto;
	background-color: #030512;
}

</style>